export function toClassName(fontFamily) {

  const className = fontFamily.name.toLowerCase().split(' ').join('-') + '-item';

  return className;

}